import { c as _c } from "react/compiler-runtime";
import ImageBlock from "@components/blocks/ImageBlock";
import { ComponentBlocksSectionImage, Maybe } from "@lib/generated/graphql";
import clsx from "clsx";
import { FC } from "react";
interface SectionImageProps {
  data?: Maybe<ComponentBlocksSectionImage>;
  index: number;
}
const SectionImage: FC<SectionImageProps> = t0 => {
  const $ = _c(16);
  const {
    data,
    index
  } = t0;
  const image = data?.image;
  if (!(data && image)) {
    return null;
  }
  const isTopAligned = image.position === "top" && data.paddingTop === "none";
  const isBottomAligned = image.position === "bottom" && data.paddingBottom === "none";
  const isOverflow = image.position === "overflow";
  const t1 = !isTopAligned && !isBottomAligned && !isOverflow;
  const t2 = data.paddingBottom === "sm";
  const t3 = data.paddingBottom === "md";
  const t4 = data.paddingTop === "sm";
  const t5 = data.paddingTop === "md";
  const t6 = !isOverflow;
  let t7;
  if ($[0] !== isBottomAligned || $[1] !== isOverflow || $[2] !== isTopAligned || $[3] !== t1 || $[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== t5 || $[8] !== t6) {
    t7 = clsx("relative max-w-[540px] mx-auto m:max-w-none m:mx-none w-full", {
      "my-m m:my-none": t1,
      "mb-m m:mb-none": isTopAligned,
      "mt-m m:mt-none": isBottomAligned,
      "m:pb-3s": t2,
      "m:pb-3xl": t3,
      "m:pt-3s": t4,
      "m:pt-3xl": t5,
      "m:-my-3s h-[calc(100%+48px)]": isOverflow,
      "m:h-full": t6
    });
    $[0] = isBottomAligned;
    $[1] = isOverflow;
    $[2] = isTopAligned;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== data.image || $[11] !== index) {
    t8 = data.image && <ImageBlock image={data.image} loading={index === 0 ? "eager" : "lazy"} />;
    $[10] = data.image;
    $[11] = index;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
export default SectionImage;